import React from 'react';
import { Link } from 'react-router-dom'; // 1. IMPORTACIÓN OBLIGATORIA PARA EL MENÚ
import { constructorWhatsapp } from '../utils/utils';
import { numVentasPrincipal } from '../config/constant';

const servicesData = [
  {
    slug: "talleres-academicos",
    title: "Desarrollo de Taller Académico",
    tag: "100% Orgánico",
    accent: "bg-blue-600",
    borderHover: "hover:border-blue-200",
    icon: (
      <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
      </svg>
    )
  },
  {
    slug: "examenes-parciales",
    title: "Ayuda en Examen / Parcial / Quiz",
    tag: "Respuesta Inmediata",
    accent: "bg-emerald-500",
    borderHover: "hover:border-emerald-200",
    icon: (
      <svg className="w-5 h-5 text-emerald-600" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    )
  },
  {
    slug: "trabajos-de-grado",
    title: "Desarrollo de Trabajos de Grado (Tesis)",
    tag: "Asesoría por Fases",
    accent: "bg-purple-600",
    borderHover: "hover:border-purple-200",
    icon: (
      <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.174L10.74 14.15a2.25 2.25 0 002.52 0l6.48-3.976m-16.5 0a2.25 2.25 0 012.25-1.934H19.5a2.25 2.25 0 012.25 1.934m-16.5 0a2.25 2.25 0 002.25 1.934H19.5a2.25 2.25 0 002.25-1.934M12 21v-8.25" />
      </svg>
    )
  },
  {
    slug: "revision-turnitin",
    title: "Revisión de Trabajos en Turnitin Premium",
    tag: "Filtro Anti-Plagio",
    accent: "bg-amber-500",
    borderHover: "hover:border-amber-200",
    icon: (
      <svg className="w-5 h-5 text-amber-600" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751A11.956 11.956 0 0112 2.714z" />
      </svg>
    )
  },
  {
    slug: "asesorias-personalizadas",
    title: "Asesorías Personalizadas",
    tag: "Clases 1-a-1",
    accent: "bg-cyan-500",
    borderHover: "hover:border-cyan-200",
    isNew: true,
    icon: (
      <svg className="w-5 h-5 text-cyan-600" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
      </svg>
    )
  },
  {
    slug: "manejo-plataformas",
    title: "Manejo de Plataforma Virtual (UNAD, Poli)",
    tag: "Gestión Anónima",
    accent: "bg-rose-500",
    borderHover: "hover:border-rose-200",
    icon: (
      <svg className="w-5 h-5 text-rose-600" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" />
      </svg>
    )
  }
];

const Services = () => {
  return (
    <section id="services" className="py-16 px-6 lg:px-16 bg-white text-center">
      
      <span className="inline-flex items-center gap-1.5 bg-slate-100 text-slate-800 text-xs font-bold px-4 py-1.5 rounded-full mb-4">
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 prompt-3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
        </svg>
        Soporte Académico Especializado
      </span>
      
      <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 tracking-tight">Nuestros Servicios</h2>
      <p className="text-slate-500 mt-2 text-sm md:text-base max-w-xl mx-auto">
        Soluciones académicas directas y eficientes adaptadas a tus necesidades reales.
      </p>

      {/* CONTENEDOR GRID DE LAS FILAS DASHBOARD */}
      <div className="mt-12 max-w-5xl mx-auto flex flex-col gap-4">
        {servicesData.map((item, idx) => (
          <div 
            key={idx}
            className={`flex flex-col lg:flex-row items-center justify-between p-5 bg-white border border-slate-200/70 rounded-2xl transition-all duration-300 group gap-5 shadow-sm relative overflow-hidden pl-6 ${item.borderHover}`}
          >
            {/* Barra lateral */}
            <div className={`absolute left-0 top-0 bottom-0 w-1 transition-all duration-300 group-hover:w-2.5 ${item.accent}`} />

            {/* Parte Izquierda: Icono + Título */}
            <div className="flex items-center gap-4 text-center sm:text-left flex-col sm:flex-row w-full lg:w-auto">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-slate-50 border border-slate-100 text-slate-700 shadow-inner flex-shrink-0 group-hover:bg-white transition-colors">
                {item.icon}
              </div>
              
              <div className="flex flex-col sm:flex-row items-center gap-3 justify-center sm:justify-start">
                <h3 className="font-bold text-slate-800 text-sm md:text-base group-hover:text-slate-950 transition-colors">
                  {item.title}
                </h3>
                {item.isNew && (
                  <span className="bg-blue-600 text-white text-[8px] font-black uppercase tracking-wider px-1.5 py-0.5 rounded shadow-sm">
                    Nuevo
                  </span>
                )}
                <span className="hidden sm:inline-block text-slate-300 font-light">|</span>
                <span className="text-[11px] font-bold text-slate-400 bg-slate-100/80 px-2.5 py-1 rounded-md">
                  {item.tag}
                </span>
              </div>
            </div>

            {/* Parte Derecha */}
            <div className="flex flex-col sm:flex-row items-center gap-2 w-full lg:w-auto border-t lg:border-t-0 border-slate-100 pt-4 lg:pt-0">
              
              {/* Botón Secundario: Detalles */}
              <Link 
                to={`/servicios/${item.slug}`}
                className="w-full sm:w-auto bg-slate-50 hover:bg-slate-100 text-slate-500 font-bold text-xs px-5 py-2.5 rounded-xl transition-all text-center border border-slate-200/50 block font-sans"
              >
                Detalles
              </Link>

              {/* RE-ESTILIZADO: Botón Comercial con Identidad 100% WhatsApp Verde */}
              <a 
                href={constructorWhatsapp(numVentasPrincipal, `Hola, deseo cotizar el servicio de: ${item.title}`)}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-600 text-white font-extrabold text-xs px-5 py-2.5 rounded-xl transition-all duration-200 shadow-sm flex items-center gap-2 justify-center"
              >
                <svg className="w-3.5 h-3.5 fill-current flex-shrink-0" viewBox="0 0 24 24">
                  <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.713-1.457L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.42 9.864-9.852.002-2.63-1.023-5.101-2.887-6.968a9.82 9.82 0 0 0-6.972-2.883c-5.433 0-9.854 4.417-9.858 9.848-.002 1.748.465 3.455 1.35 4.98L1.945 22.1l4.702-1.233z"/>
                </svg>
                Cotizar
              </a>
            </div>

          </div>
        ))}
      </div>

    </section>
  );
};

export default Services;